module.exports = __webpack_public_path__ + "static/media/img-experiments.9ca8897a.jpg";